import React from 'react';
import { GatsbySSR, WrapRootElementNodeArgs } from 'gatsby';
import { ElasticApm } from 'common/components/ElasticApm';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from '@theme';
import './styles.css';

const MainWrapper: GatsbySSR['wrapRootElement'] = ({ element }: WrapRootElementNodeArgs) => (
  <ElasticApm>
    <ThemeProvider theme={theme}>
      <CssBaseline>{element}</CssBaseline>
    </ThemeProvider>
  </ElasticApm>
);

export default MainWrapper;
